const messages = {
  en: {
    share: 'Share',
    copyUrl: 'Copy url to clipboard',
    copied: 'Copied!'
  },
  'es-ud': {
    share: 'Compartir',
    copyUrl: 'Copiar url al portapapeles',
    copied: 'Copiado!'
  },
  es: {
    share: 'Compartir',
    copyUrl: 'Copiar url al portapapeles',
    copied: 'Copiado!'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/SocialMedia/messages.js